import React, { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { DBSProduct } from 'types';
import * as S from './styles';

interface OffersDetailsSectionProps {
  title: string;
  subTitle?: ReactNode;
  warning?: ReactNode | string;
  notice?: string | ReactNode;
  children?: ReactNode | string;
  headerItem?: ReactNode | string;
  promotedProduct?: DBSProduct | null;
  selectedOfferId: string | undefined;
  testId?: string;
}

const OffersDetailsSection: React.FC<OffersDetailsSectionProps> = ({
  testId = 'offers-details-section',
  title,
  subTitle,
  warning,
  children,
  headerItem,
  promotedProduct,
  selectedOfferId,
}) => (
  <Grid container columnSpacing={4} component="section" data-testid={testId}>
    <S.TitleContainer item xs={12} md={promotedProduct && !selectedOfferId ? 8 : 12}>
      <S.Title variant="h3">{title}</S.Title>
      {headerItem}
    </S.TitleContainer>
    {subTitle}
    {warning && (
      <S.DetailsHeader item xs={12} md={promotedProduct ? 8 : 12}>
        <S.DetailsSectionWarning vairant="subtitle2">{warning}</S.DetailsSectionWarning>
      </S.DetailsHeader>
    )}
    {children}
  </Grid>
);

export default OffersDetailsSection;
